import React from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SuccessMessageUI from '../../../widgets/form/SuccessMessageUI'
import ErrorMessageUI from '../../../widgets/form/ErrorMessageUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import ButtonUI from '../../../widgets/action/ButtonUI'
import ButtonTinyUI from '../../../widgets/action/ButtonTinyUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import { Link } from 'react-router-dom'

const ReconciliationUI = ({ context, accountNumber, txnList, bankTxnList,
  onCopyToClipboard, copyToClipboardText, onUploadClick, onOtherUploadClick,
  onRefreshClick, onReconcileClick, reconcileSubmitted, successMsg, errorList,
  onCheckboxAppTxnClick, onCheckboxBankTxnClick, selectedAppTxnId, selectedBankTxnId,
  onNachReconciliationClick, onIciciReconciliationClick
}) =>
  <div className='su_recon'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          onRefreshClick={onRefreshClick}
          accountNumber={accountNumber}
        />
      }
      right={
        <ActionRightUI
          context={context}
          txnList={txnList} bankTxnList={bankTxnList}
          onUploadClick={onUploadClick}
          onOtherUploadClick={onOtherUploadClick}
          reconcileSubmitted={reconcileSubmitted} onReconcileClick={onReconcileClick}
          onNachReconciliationClick={onNachReconciliationClick}
          selectedBankTxnId={selectedBankTxnId}
          onIciciReconciliationClick={onIciciReconciliationClick}
        />
      }
    />

    <SuccessMessageUI successMsg={successMsg} />
    <ErrorMessageUI errorList={errorList} />

    {
      txnList.length === 0 && bankTxnList.length === 0 &&
      <EmptyListUI
        context={context}
        createEnabled={false}
        createDisabledMessageLabel='No transactions to reconcile'
      />
    }

    {
      bankTxnList.length > 0 &&
      <div>
        <div className='g_m_left_50 g_m_bottom_50 g_flex_h'>
          <b>Bank Statement Transactions</b>
          <span>{bankTxnList.length} transaction{bankTxnList.length == 1 ? '' : 's'}</span>
        </div>
        <LRTableBodyUI>
          {
            bankTxnList.map((bankTxn, i) =>
              <BankTxnRowList key={i} context={context} bankTxn={bankTxn}
                onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
                onCheckboxBankTxnClick={onCheckboxBankTxnClick} selectedBankTxnId={selectedBankTxnId}
              />
            )
          }
        </LRTableBodyUI>
      </div>
    }

    {
      txnList.length > 0 &&
      <div className='g_m_top_100'>
        <div className='g_m_left_50 g_m_bottom_50 g_flex_h'>
          <b>Escrow Account Transactions</b>
          <span>{txnList.length} transaction{txnList.length == 1 ? '' : 's'}</span>
        </div>
        <LRTableBodyUI>
          {
            txnList.map((txn, i) =>
              <TxnRowList key={i} context={context} txn={txn}
                onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
                onCheckboxAppTxnClick={onCheckboxAppTxnClick} selectedAppTxnId={selectedAppTxnId}
              />
            )
          }
        </LRTableBodyUI>
      </div>
    }
  </div>

const TxnRowList = ({ context, txn, onCopyToClipboard, copyToClipboardText, onCheckboxAppTxnClick, selectedAppTxnId }) =>
  <LRTableRowUI
    context={context} className='g_flex_top'
    left={<RowLeftUI context={context} txn={txn}
      onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
    />}
    right={
      <RowRightUI context={context} txn={txn}
        selectedAppTxnId={selectedAppTxnId} onCheckboxAppTxnClick={onCheckboxAppTxnClick}
      />
    }
  />

const RowLeftUI = ({ context, txn, onCopyToClipboard, copyToClipboardText }) =>
  <div className='g_flex_v'>
    <span className=''>
      {txn.transactionDateF}
      <span className='g_muted g_m_left_50'>{txn.transactionId}</span>
      <span onClick={e => e.stopPropagation()}>
        <CopyToClipboard text={txn.transactionId}
          onCopy={onCopyToClipboard}>
          <span className='g_m_left_50 g_muted icon icon-clone g_cursor_pointer' />
        </CopyToClipboard>
        {
          copyToClipboardText === txn.transactionId &&
          <span className='g_m_left_50 g_muted'>copied</span>
        }
      </span>
    </span>
    <span className='g_small'>
      {txn.bankAccountNumber}
      <span className='g_muted g_m_left_50'>{txn.referenceId}</span>
      <span className='g_muted g_m_left_50'>{txn.cmsCorrelationNum}</span>
    </span>
    {
      txn.type &&
      <span className='g_m_top_25'>
        <BadgeUI label={txn.typeBadge} />
        <span className='g_m_left_50'><b>{txn.accountName}</b></span>
        {
          txn.remitter &&
          <span className='g_m_left_50 icon icon-angle-left'> {txn.remitter}</span>
        }
        {
          txn.payee &&
          <span className='g_m_left_50 icon icon-angle-right'> {txn.payee}</span>
        }
      </span>
    }
  </div>

const RowRightUI = ({ context, txn, selectedAppTxnId, onCheckboxAppTxnClick }) =>
  <div className='g_flex_v g_text_right'>
    <span>{`${txn.amount < 0 ? '(' : ''}` + txn.amountF1 + `${txn.amount < 0 ? ')' : ''}`}</span>
    <span className='g_m_top_25'>
      <BadgeUI label={txn.reconciliationStatus} />
    </span>
    {
      context.permissions.includes('su_superuser') &&
      <input className='g_m_left_100 checkbox' type='checkbox'
        checked={selectedAppTxnId === txn.transactionId} onChange={onCheckboxAppTxnClick} data-id={txn.transactionId}></input>
    }
  </div>

const BankTxnRowList = ({ context, bankTxn, onCopyToClipboard, copyToClipboardText, onCheckboxBankTxnClick, selectedBankTxnId }) =>
  <LRTableRowUI
    context={context} className='g_flex_top'
    left={<BankTxnRowLeftUI context={context} bankTxn={bankTxn}
      onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
    />}
    right={
      <BankTxnRowRightUI context={context} bankTxn={bankTxn}
        selectedBankTxnId={selectedBankTxnId} onCheckboxBankTxnClick={onCheckboxBankTxnClick}
      />
    }
  />

const BankTxnRowLeftUI = ({ context, bankTxn, onCopyToClipboard, copyToClipboardText }) =>
  <div className='g_flex_v'>
    <span className=''>
      {bankTxn.transactionDateF}
      <span className='g_muted g_m_left_50'>{bankTxn.iciciTransactionId}</span>
      <span onClick={e => e.stopPropagation()}>
        <CopyToClipboard text={bankTxn.iciciTransactionId}
          onCopy={onCopyToClipboard}>
          <span className='g_m_left_50 g_muted icon icon-clone g_cursor_pointer' />
        </CopyToClipboard>
        {
          copyToClipboardText === bankTxn.iciciTransactionId &&
          <span className='g_m_left_50 g_muted'>copied</span>
        }
      </span>
    </span>
    <span className='g_small'>{bankTxn.particulars}</span>
  </div>

const BankTxnRowRightUI = ({ context, bankTxn, selectedBankTxnId, onCheckboxBankTxnClick }) =>
  <div className='g_flex_v g_text_right'>
    <span>{`${bankTxn.amount < 0 ? '(' : ''}` + bankTxn.amountF1 + `${bankTxn.amount < 0 ? ')' : ''}`}</span>
    <span className='g_m_top_25'>
      <BadgeUI label={bankTxn.reconciliationStatus} />
    </span>
    {
      context.permissions.includes('su_superuser') &&
      <input className="g_m_left_100 checkbox" type='checkbox' onChange={onCheckboxBankTxnClick}
        checked={selectedBankTxnId === bankTxn.iciciTransactionId} data-id={bankTxn.iciciTransactionId} />
    }
  </div>

const ActionLeftUI = ({ context, onRefreshClick, accountNumber }) =>
  <div className='g_flex_h'>
    <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
    <span className='g_m_left_100 g_large'><b>Unreconciled Transactions in {accountNumber}</b></span>
  </div>

const ActionRightUI = ({ context, txnList, bankTxnList, onUploadClick, onOtherUploadClick,
  reconcileSubmitted, onReconcileClick, selectedAppTxnId, selectedBankTxnId, onNachReconciliationClick,
  onIciciReconciliationClick
}) =>
  <div>
    <div className='g_flex_h'>
      {
        context.permissions.includes('su_superuser_business') &&
        (txnList.length > 0 || bankTxnList.length > 0) &&
        <>
          <SpinnerUI show={reconcileSubmitted} className='g_m_right_50' />
          <ButtonUI label='Reconcile' onClick={onReconcileClick} />
          <span className='g_m_left_50' />
        </>
      }
      {
        context.permissions.includes('su_manage') &&
        <div className='g_flex_v'>
          <ButtonTinyUI label='Upload CSV Statement' onClick={onUploadClick} />
          <ButtonTinyUI className='g_m_top_50' label='Upload TSV Statement' onClick={onOtherUploadClick} />
        </div>
      }
    </div>
    {
      selectedBankTxnId &&
      <div className='g_m_top_100 g_flex_h'>
        <Link onClick={onIciciReconciliationClick} to='#'>Copy ICICI Transaction</Link>
        <Link className='g_m_left_100' onClick={onNachReconciliationClick} to='#'>NACH Reconciliation</Link>
      </div>
    }
  </div>

export default ReconciliationUI
